import libForm from "../../../../util/libForm";
import RadioInput from "../../../../components/inputs/radio";
import TextInput from "../../../../components/inputs/text";
import { useEffect } from "react";
import { IndexHook } from "../../../../components/filter/register-basic/hook";
import { Switch } from "@mui/material";
import { BtnSearch } from "../../../../components/button/button-search";
import HeaderFilter from "../../../../components/header/filter";

const FilterScheduledPauses = ({ options, handleSubmitModalFilter, reloadFilter }) => {
	const parameters = options.parametersFilter;

	const {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setValue,
		control,
		Controller,
	} = IndexHook({ options, handleSubmitModalFilter });

	useEffect(() => {
		try {
			if (reloadFilter) {
				Object.keys(reloadFilter).forEach((field) => {
					setValue(field, reloadFilter[field]);
				});
			} else {
				// Valor padrão para o primeiro parâmetro se necessário
			}
		} catch (error) {}
	}, [reloadFilter]);

    // Quando o parâmetro é "tipo", podemos oferecer um select com as opções fixas
    useEffect(() => {
        if (paramSelected?.value === "tipo") {
            setValue("paramValue", "AMBOS");
        } else {
            setValue("paramValue", "");
        }
    }, [paramSelected?.value]);

	return (
		<div className="">
			<form onSubmit={handleSubmit(handleOnSubmit)} action="submit">
				<HeaderFilter title={options.title} />

				<div className="border-bottom">
					<div className="row mt-2">
						{parameters.map((item) => (
							<RadioInput key={item.id} item={item} id={"param"} register={register} control={control} />
						))}
					</div>
					<div className="flex-wrap ">
						<div className="check-input d-flex align-items-center justify-content-end">
							<Controller
								name="active"
								control={control}
								defaultValue={true}
								render={({ field }) => (
									<Switch
										checked={field.value}
										onChange={(e) => field.onChange(e.target.checked)}
										inputProps={{
											"aria-label": "Ativos",
										}}
									/>
								)}
							/>
							<label htmlFor="active">Ativo</label>
							{errors.active && <p className="errors">{errors.active.message}</p>}
						</div>
					</div>

					{paramSelected?.value === "tipo" ? (
						<div className="input-select-box d-flex flex-column mt-2">
							<label htmlFor="paramValue">{paramSelected.label}</label>
							<select {...register("paramValue")} onKeyDown={(e) => libForm.EnterTab(e)}>
								<option value="LOJA">Loja</option>
								<option value="DELIVERY">Delivery</option>
								<option value="AMBOS">Ambos</option>
							</select>
							{errors.paramValue && <p className="errors">{errors.paramValue.message}</p>}
						</div>
					) : (
						<TextInput
							label={paramSelected.label}
							id="paramValue"
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							autoFocus={true}
							className={"mt-2"}
						/>
					)}
				</div>
				<footer>
					<div></div>
					<BtnSearch isSubmitting={isSubmitting} />
				</footer>
			</form>
		</div>
	);
};

export default FilterScheduledPauses;
